import React from 'react';
import {useSpring, animated} from "react-spring";

const MenuButton = ({toggle, setButton}) => {

const {x1} = useSpring({
    reset: !toggle,
    x1: toggle ? 0:1,
    delay: toggle ? 0:300,
    config: {duration: 200}
});
const {x2} = useSpring({
    reset: toggle,
    x2: !toggle ? 0:1,
    delay: !toggle ? 0:300,
    config: {duration: 200}
});


    return(
        <div>
            <animated.svg className={"nav-toggle " + (toggle ? " toggle-off" :"")} strokeDasharray={24} strokeDashoffset={x1.to(x1 => (1-x1) * 24)} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" onClick={() => setButton(true)}>
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"/>     
            </animated.svg>
            <animated.svg className={"nav-toggle " + (!toggle ? " toggle-off":"")} viewBox="0 0 24 24" strokeDasharray={24} strokeDashoffset={x2.to(x2 => (1-x2) * 24)} xmlns="http://www.w3.org/2000/svg" onClick={() => setButton(false)}>
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
            </animated.svg>
        </div>
    )
}

export default MenuButton;